import { GET_REQUEST_REPORT } from '../../types/Types';

const submitRequestReportForm = (data) => ({
  type: GET_REQUEST_REPORT,
  data,
});

export default submitRequestReportForm;
